import React from "react";
import ReactSlider from "react-slider";
import type { ReactSliderProps } from "react-slider";
import "./HorizontalSlider.scss";
import classNames from "classnames";
import { withDefaults } from "../../utils/withDefaults";

/** The render function react-slider calls for the draggable thumb. */
export type RenderThumb = NonNullable<ReactSliderProps<number>["renderThumb"]>;

export interface HorizontalSliderProps {
  onChange?: (value: number) => void;
  value?: number;
  min?: number;
  max?: number;
  /** `id` put on the default thumb, so tests and focus calls can find it. */
  thumbId?: string;
  renderThumb?: RenderThumb;
  thumbClassName?: string;
  className?: string;
  showMarks?: boolean;
}

export default function HorizontalSlider(
  incomingProps: HorizontalSliderProps
) {
  const props = withDefaults(incomingProps, horizontalSliderDefaultProps);

  const thumbId = props.thumbId;

  const onSliderChange = (newVal: number) => {
    props.onChange(newVal);
  };

  const getRenderThumbFn = (): RenderThumb => {
    if (props.renderThumb) {
      return props.renderThumb;
    }
    return thumbProps => (
      <div {...thumbProps} data-testid="slider-thumb" id={thumbId} />
    );
  };

  return (
    <ReactSlider
      className={classNames("horizontal-slider", props.className)}
      thumbClassName={classNames("thumb", props.thumbClassName)}
      trackClassName="track"
      min={props.min}
      max={props.max}
      value={props.value}
      withTracks={true}
      onChange={onSliderChange}
      renderThumb={getRenderThumbFn()}
    />
  );
}

const horizontalSliderDefaultProps = {
  onChange: () => {},
  value: 0,
  min: 0,
  max: 10,
  thumbId: "",
  thumbClassName: "",
  className: ""
};
